/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ProjectSettingsServiceDeskAutomationViewLogType from '@jira/spa-apps__project-settings-service-desk-automation-view-log/src/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyProjectSettingsServiceDeskAutomationViewLog: LazyComponent<
	() => React.JSX.Element
> = lazyForPaint<typeof ProjectSettingsServiceDeskAutomationViewLogType>(
	() =>
		import(
			/* webpackChunkName: "async-project-settings-service-desk-automation-view-log", jiraSpaEntry: "async-project-settings-service-desk-automation-view-log" */ '@jira/spa-apps__project-settings-service-desk-automation-view-log/src/index.tsx'
		),
);

const AsyncProjectSettingsServiceDeskAutomationViewLog = (): React.JSX.Element => (
	<LazyPage
		Page={LazyProjectSettingsServiceDeskAutomationViewLog}
		pageId="project-settings-automation-view-log"
		shouldShowSpinner
	/>
);

export default AsyncProjectSettingsServiceDeskAutomationViewLog;
